/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import type { RemoteConfigType, RemoteConfigValue } from './remoteConfig.types';

/** The value returned before the remote value resolves, per type. */
export const defaultRemoteConfigValue = (
  type: RemoteConfigType,
): RemoteConfigValue => {
  if (type === 'boolean') return false;
  if (type === 'number') return 0;
  return '';
};

/** Coerces a raw string (e.g. from the native bridge) to the requested type. */
export const castRemoteConfigValue = (
  raw: string | undefined,
  type: RemoteConfigType,
): RemoteConfigValue => {
  if (raw == null) return defaultRemoteConfigValue(type);
  if (type === 'boolean') return raw === 'true';
  if (type === 'number') {
    const parsed = Number(raw);
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return raw;
};
